





















import Vue from "vue";
import feedMixin from "@/mixins/feed";
import ssoMixin from "@/mixins/sso";
import { formatSize } from "@/utils/util";
import staticIcons from "@/utils/static-icons";
import { parseTime } from "@/utils/filters";

export default Vue.extend({
  name: "FeedFileItem",
  filters: {
    displayFileIcon(item: any) {
      return item.icon_link || staticIcons.other;
    },
    parseTime(time: string) {
      return parseTime(time, "{y}-{m}-{d} {h}:{i}");
    },
  },
  mixins: [feedMixin, ssoMixin],
  props: ["info", "feed", "selected", "from"],
  data() {
    return {
      checked: this.selected.includes(this.info.id),
    };
  },
  computed: {
    curUser() {
      return this.$store.state.user.curUser;
    },
    hasLogin() {
      return this.curUser.userId !== "0";
    },
    folders() {
      return this.$store.state.share.folders;
    },
  },
  watch: {
    selected(val) {
      this.checked = val.includes(this.info.id);
    },
  },
  async mounted() {},
  methods: {
    formatSize,
    handleNameClick() {
      // this.$emit("check-folder", { info: this.info });
    },
    handleSelect(val: any) {
      this.$emit("select-change", { info: this.info, checked: val });
    },
    handleSingleSave() {
      let ancestorIds = [];
      if (this.folders.length >= 1 && this.folders[0].id === "0") {
        ancestorIds = this.folders
          .filter((v: any) => v.id !== "0")
          .map((v: any) => v.id);
      }

      this.stat("xiaozhan_collect_btn_click", {
        from: this.from,
        position: "detail_page",
        is_collect_all_file: this.feed.files.length === 1 ? 1 : 0,
        is_login: this.hasLogin ? 1 : 0,
        upUid: this.feed.user_info ? this.feed.user_info.user_id : "",
        cardID: this.feed.id,
      });

      this.handleSave(
        this.feed,
        [this.info.id],
        ancestorIds,
        "detail",
        false,
        this.from
      );
    },
    handleSingleDownload() {
      this.$emit("download", [this.info]);
    },
  },
});
